import IComponent from "components/commons/IComponent";
import "./GIDetailUi.scoped.css";
import DivTable from "components/commons/DivTable";
import geometryTools from "utils/geometryTools";
import config_zoomto from "components/ZoomTo/config_zoomto";
import * as query from "@arcgis/core/rest/query.js";
import DownloadFromWebAPI from "utils/DownloadFromWebAPI";
import Button from "@material-ui/core/Button";
import ICN_report from "./GIDetailUIIcons/report.png";
import ICN_package from "./GIDetailUIIcons/package.png";
import ICN_package2 from "./GIDetailUIIcons/package2.png";
import GetArcGISToken from "utils/GetArcGISToken";

let cachedDrillholes = {};
class ClassName extends IComponent {
  constructor(props) {
    super(props);
    this.state = {
      drillholes: undefined,
      giDetailQueried: undefined,
    };
  }
  componentDidMount() {
    console.debug(this.props);
    let gLayerForGIDrillhole = geometryTools.createGraphicsLayerById(
      "gLayerForGIDrillhole",
      this.props.mapView.map
    );
    let highlightLayerForGIDrillhole = geometryTools.createGraphicsLayerById(
      "highlightLayerForGIDrillhole",
      this.props.mapView.map
    );
    gLayerForGIDrillhole && gLayerForGIDrillhole.removeAll();
    highlightLayerForGIDrillhole && highlightLayerForGIDrillhole.removeAll();

    this.queryForHoles();
    this.queryForReport();
    this.toggleSearchResultLayer(false);
  }
  componentWillUnmount() {
    this.highlightGraphic(null, true);
    geometryTools.clearGraphicsByLayerId(
      "gLayerForGIDrillhole",
      this.props.mapView.map
    );
    geometryTools.clearGraphicsByLayerId(
      "highlightLayerForGIDrillhole",
      this.props.mapView.map
    );
    this.toggleSearchResultLayer(true);
  }
  toggleSearchResultLayer(value) {
    let gLayer = geometryTools.createGraphicsLayerById(
      "highlightLayerForMMS",
      this.props.mapView.map
    );
    gLayer.visible = value;
  }
  async queryForHoles() {
    let repNo = this.props.item.key;
    if (repNo in cachedDrillholes) {
      this.setState({ drillholes: cachedDrillholes[repNo] });
      geometryTools.refreshGraphicByLayerId(
        this.props.mapView,
        "gLayerForGIDrillhole",
        cachedDrillholes[repNo].map((i) => i.geometry),
        true
      );
      return;
    }
    let searchInfo = config_zoomto.TEXTUAL_SEARCH_LIST.find(
      (i) => i.type === "gireport"
    );
    let layerId = searchInfo?.layerId;
    let field = searchInfo?.fields?.[0];
    let queryUrl = config_zoomto.TEXUAL_SEARCH_LAYER_URL + "/" + layerId;
    let queryPara = {
      outFields: ["*"],
      returnGeometry: true,
      where: `${field} = '${repNo}'`,
    };
    let drillholes = await query.executeQueryJSON(queryUrl, queryPara, {
      userProxy: this.$config.useEsriProxy,
    });
    if (drillholes.features.length > 0) {
      geometryTools.refreshGraphicByLayerId(
        this.props.mapView,
        "gLayerForGIDrillhole",
        drillholes.features.map((i) => i.geometry),
        true
      );
    }
    drillholes = drillholes.features.map((i) => ({
      ...i.attributes,
      geometry: i.geometry,
    }));
    cachedDrillholes[repNo] = drillholes;
    this.setState({ drillholes });
  }
  async highlightGraphic(row, clear = false) {
    if (clear) {
      geometryTools.clearGraphicsByLayerId(
        "highlightLayerForGIDrillhole",
        this.props.mapView.map
      );
      return;
    }
    let cloneGraphic = new geometryTools.Graphic({
      geometry: row.geometry,
      symbol: geometryTools.highlightSymbol.point,
    });
    cloneGraphic.symbol.color = "#FF0000";
    geometryTools
      .createGraphicsLayerById(
        "highlightLayerForGIDrillhole",
        this.props.mapView.map
      )
      .add(cloneGraphic);
  }
  async queryForReport() {
    let searchInfo = this.props.searchInfo;
    if (searchInfo.searchType === "EXACT") {
      this.setState({ giDetailQueried: this.props.item.attributes });
      return;
    }

    let repno = this.props.item.key;
    let giResult = await this.fetchQueryByPOST(
      `${this.$config.webSrvUrl}WebAPI/GInfo/GIReportInfo`,
      { Key: repno }
    );
    giResult = await giResult.json();
    console.debug(giResult);
    this.setState({ giDetailQueried: giResult });
  }
  showGovReportDialog() {
    let data = this.state.giDetailQueried;
    if (GetArcGISToken.user.userGroup === 5 && data.REPCLASS !== "GOVERNMENT") {
      this.props.showDialog({
        isOpen: true,
        title: "Non-government report",
        content: (
          <div>
            This GI Report is non-government report.
            <br />
            <br />
            Please visit CE library to obtain GI Report or you may wish to check
            if electronic GI reports are kept in "Building Records Access and
            Viewing On-line" System of Buildings Department.
            <br />
            <br />
            <a href="https://bravo.bd.gov.hk" target="_blank">
              https://bravo.bd.gov.hk
            </a>
          </div>
        ),
        onDialogOk: () => {},
      });
      return true;
    }
  }
  makeDrillholeInfoBlock() {
    let attrCheckList = { DEPTH: 1, STATNO: 1, STATTYPE: 1 };
    let attr = { ...this.props.item.attributes };
    attr = Object.keys(attr).reduce((p, c, i) => {
      let newC = c;
      let dotPos = c.lastIndexOf(".");
      if (dotPos > -1) newC = newC.substring(dotPos + 1);
      if (newC in attrCheckList) p[newC] = attr[c];
      return p;
    }, {});
    return (
      <table width={"100%"}>
        <tbody>
          <tr>
            <td>Drillhole No.</td>
            <td>{attr.STATNO}</td>
          </tr>
          <tr>
            <td>Drillhole Type</td>
            <td>{attr.STATTYPE}</td>
          </tr>
          <tr>
            <td>Drillhole Depth</td>
            <td>{attr.DEPTH}</td>
          </tr>
        </tbody>
      </table>
    );
  }
  render() {
    let data = this.state.giDetailQueried;
    let drillholes = this.state.drillholes;

    if (typeof data === "undefined" || typeof drillholes === "undefined") {
      return (
        <div className="SubPanelContent GIDetailContainer">
          <span className="icn_loading" /> Loading the report, please wait...
        </div>
      );
    }

    return (
      <div className="GIDetailContainer">
        <div className="BottomLine EqualWidthChildren">
          <div
            style={!this.props.showBackButton ? { display: "none" } : {}}
            className="BackButton"
            onClick={() => this.props.onSubPanelCallback("goBack")}
          >
            <span className="icn_back" />
          </div>
          <div className="Shrink2 ResultItemName">
            &nbsp;{this.props.item.key}
          </div>
          <div className="SubPanelContent AlignRight PDFLinkBar">
            <Button
              variant="outlined"
              onClick={() =>
                !this.showGovReportDialog() &&
                window.open(
                  data.PDF ? DownloadFromWebAPI(data.PDF) : "about:blank"
                )
              }
            >
              <img src={ICN_report} />
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                if (this.showGovReportDialog()) return;
                if (data.AGSFILE !== "N/A")
                  window.open(DownloadFromWebAPI(data.AGSFILE));
                else
                  this.props.showDialog({
                    type: "info",
                    isOpen: true,
                    title: "AGS",
                    content:
                      "No electronic copy of GI report in AGS format. Please visit CE library to obtain hard copy.",
                    onDialogOk: () => {},
                  });
              }}
            >
              <img src={ICN_package} />
            </Button>
            {(GetArcGISToken.user.userGroup === 1 ||
              GetArcGISToken.user.userGroup === 2 ||
              GetArcGISToken.user.userGroup === 3 ||
              GetArcGISToken.user.userGroup === 8) && (
              <Button
                variant="outlined"
                onClick={() => {
                  if (this.showGovReportDialog()) return;
                  this.props.showDialog({
                    type: "info",
                    isOpen: true,
                    title: "AGS 3.1",
                    content: (
                      <div>
                        <p>
                          The AGS version 3.1 data is modified from the
                          contractors' AGS data and is for reference only. The
                          GEO gives no warranty that the AGS version 3.1 data is
                          error-free. The GEO shall under no circumstances
                          whatsoever be responsible for or held responsible for
                          any loss or claims for damage to any property
                          whatsoever which may arise from or in consequence of
                          relying on the AGS version 3.1 data.
                        </p>
                        <p>
                          {data.AGSFILE_NEW !== "N/A" ? (
                            <a
                              href={DownloadFromWebAPI(data.AGSFILE_NEW)}
                              target="_blank"
                            >
                              Click here to download the file
                            </a>
                          ) : (
                            "No electronic copy of GI report in AGS format. Please visit CE library to obtain hard copy."
                          )}
                        </p>
                      </div>
                    ),
                    onDialogOk: () => {},
                  });
                }}
              >
                <img src={ICN_package2} />
              </Button>
            )}
          </div>{" "}
        </div>
        {this.props.searchInfo.name !== "GIU Report" && (
          <div className="SubPanelContent EqualWidthChildren">
            {this.makeDrillholeInfoBlock()}
            <div className="AlignRight">
              <Button
                variant="outlined"
                onClick={() => {
                  if (this.showGovReportDialog()) return;
                  this.props.showDialog({
                    isOpen: true,
                    title: "Report",
                    content: (
                      <ol>
                        {data.BOREHOLEPDFS.map((i) => (
                          <li>
                            <a href={DownloadFromWebAPI(i.URL)} target="_blank">
                              {i.FileName}
                            </a>
                          </li>
                        ))}
                      </ol>
                    ),
                    onDialogOk: () => {},
                  });
                }}
              >
                <img src={ICN_report} />
              </Button>
            </div>
          </div>
        )}
        <div className="SubPanelContent">
          <table width={"100%"}>
            <tbody>
              <tr>
                <td>GIU Report No.</td>
                <td>{data.REPNO}</td>
              </tr>
              <tr>
                <td>Title</td>
                <td>{data.TITLE}</td>
              </tr>
              <tr>
                <td>Report Type</td>
                <td>{data.REPTYPE}</td>
              </tr>
              <tr>
                <td>Author</td>
                <td>{data.AUTHOR}</td>
              </tr>
              <tr>
                <td>Work Order No.</td>
                <td>{data.WORKNO}</td>
              </tr>
              <tr>
                <td>Contract No.</td>
                <td>{data.CONTRACT}</td>
              </tr>
              <tr>
                <td>Classification</td>
                <td>{data.REPCLASS}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="SubPanelContent relatedReportTable">
          <DivTable
            data={data?.REL_REPs}
            columnDef={[
              { name: "Related Report No.", value: "REL_REP", width: "200px" },
              {
                name: "Title",
                value: "TITLE",
                format: (val, row) => (
                  <a
                    href="#"
                    target="_blank"
                    onClick={(evt) => {
                      !this.showGovReportDialog() &&
                        window.open(DownloadFromWebAPI(row.URL));
                      evt.preventDefault();
                    }}
                  >
                    {val}
                  </a>
                ),
              },
            ]}
            noDataText={
              data?.REL_REPs?.length === 0 && "No related report found."
            }
          />
        </div>
        <div className="SubPanelContent relatedReportTable">
          <DivTable
            data={drillholes.sort((a, b) => {
              if (a.STATNO < b.STATNO) {
                return -1;
              } else if (a.STATNO > b.STATNO) {
                return 1;
              } else {
                return 0;
              }
            })}
            columnDef={[
              {
                name: "Drillhole No.",
                value: "STATNO",
                format: (value, row) => (
                  <span
                    className="BookmarkLink"
                    onClick={() => {
                      geometryTools.zoomToGraphic(this.props.mapView, [
                        row.geometry,
                      ]);
                    }}
                    onMouseOver={() => this.highlightGraphic(row)}
                    onMouseLeave={() => this.highlightGraphic(row, true)}
                  >
                    {value}
                  </span>
                ),
              },
              { name: "Drillhole Type", value: "STATTYPE" },
              { name: "Drillhole Depth", value: "DEPTH" },
            ]}
            noDataText={
              drillholes?.length === 0 && "No related drillhole found."
            }
          />
        </div>
      </div>
    );
  }
}

export default ClassName;
